import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";


import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import "@fortawesome/fontawesome-free/css/all.css"; // Ensure you are using css-loader

import vuejquery from "vue-jquery";

import jQuery from "jquery";
global.jQuery = jQuery;
global.$ = jQuery;

Vue.use(jQuery);
Vue.use(vuejquery);

Vue.use(Vuetify, {
  iconfont: "fa"
});

import Vuetify from "vuetify";

Vue.use(Vuetify, {
  iconfont: "fa",
  icons: {
    menu: "fa fa-ban"
  }
});

Vue.use(VueMaterial);

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  router,
  BootstrapVue,
  render: h => h(App)
}).$mount("#app");
